<template>
  <div>
    <el-form-item
      :label="label"
      :rules="rules"
      :prop="loadPropPath($i18n.locale)"
    >
      <el-input
        class="input-item"
        :value="value[$i18n.locale]"
        :placeholder="defaultLocale.title"
        @input="value => onDefaultDataChange($i18n.locale, value)"
      >
        <el-button
          tabindex="-1"
          slot="append"
          :icon="collapseIcon"
          @click="onToggleCollapse"
        ></el-button>
      </el-input>
    </el-form-item>
    <template v-if="!collapsed">
      <el-form-item
        v-for="locale in nonDefaultLocales"
        :rules="rules"
        :prop="loadPropPath(locale.code)"
      >
        <el-input
          class="input-item"
          :key="locale.code"
          :value="value[locale.code]"
          @input="value => onDataChange(locale.code, value)"
          :placeholder="locale.title"
        ></el-input>
      </el-form-item>
    </template>
  </div>
</template>

<script>
export default {
  name: "I18nInput",
  props: {
    label: {
      type: String,
      required: false
    },
    prop: {
      type: String,
      default: null,
      required: false
    },
    value: {
      type: Object,
      default: null
    }
  },
  data() {
    let i18nObj = {};
    this.$locales.forEach(locale => {
      i18nObj[locale.code] = "";
    });
    return {
      collapsed: true,
      uzCYRAlphabet: [
        "А", //1
        "а", //1
        "Б", //2
        "б", //2
        "В", //3
        "в", //3
        "Г", //4
        "г", //4
        "Д", //5
        "д", //5
        "Е", //6
        "е", //6
        "Ё", //7
        "ё", //7
        "Ж", //8
        "ж", //8
        "З", //9
        "з", //9
        "И", //10
        "и", //10

        "Й", //11
        "й", //11
        "К", //12
        "к", //12
        "Л", //13
        "л", //13
        "М", //14
        "м", //14
        "Н", //15
        "н", //15
        "О", //16
        "о", //16
        "П", //17
        "п", //17
        "Р", //18
        "р", //18
        "С", //19
        "с", //19
        "Т", //20
        "т", //20

        "У", //21
        "у", //21
        "Ф", //22
        "ф", //22
        "Х", //23
        "х", //23
        "Ц", //24
        "ц", //24
        "Ч", //25
        "ч", //25
        "Ш", //26
        "ш", //26
        "Э", //27
        "э", //27
        "Ю", //28
        "ю", //28
        "Я", //29
        "я", //29
        "Ў", //30
        "ў", //30

        "Қ", //31
        "қ", //31
        "Ғ", //32
        "ғ", //32
        "Ҳ", //33
        "ҳ", //33
        "Ъ", //34
        "ъ", //34
        "Ь", //35
        "ь" //35
      ],
      uzUZAlphabet: [
        "A", //1
        "a", //1
        "B", //2
        "b", //2
        "V", //3
        "v", //3
        "G", //4
        "g", //4
        "D", //5
        "d", //5
        "Ye", //6
        "ye", //6
        "Yo", //7
        "yo", //7
        "J", //8
        "j", //8
        "Z", //9
        "z", //9
        "I", //10
        "i", //10

        "Y", //11
        "y", //11
        "K", //12
        "k", //12
        "L", //13
        "l", //13
        "M", //14
        "m", //14
        "N", //14
        "n", //15
        "O", //16
        "o", //16
        "P", //17
        "p", //17
        "R", //18
        "r", //18
        "S", //19
        "s", //19
        "T", //20
        "t", //20

        "U", //21
        "u", //21
        "F", //22
        "f", //22
        "X", //23
        "x", //23
        "Ts", //24
        "ts", //24
        "Ch", //25
        "ch", //25
        "Sh", //26
        "sh", //26
        "E", //27
        "e", //27
        "Yu", //28
        "yu", //28
        "Ya", //29
        "ya", //29
        "O'", //30
        "o'", //30

        "Q", //31
        "q", //31
        "G'", //32
        "g'", //32
        "H", //33
        "h", //33
        "'", //34
        "'", //34
        "'", //35
        "'" //35
      ],
      rules: this.prop
        ? [
            {
              required: true,
              message: this.$t("requiredField"),
              trigger: "change"
            }
          ]
        : []
    };
  },
  computed: {
    collapseIcon() {
      return `el-icon-caret-${this.collapsed ? "left" : "bottom"}`;
    },
    defaultLocale() {
      return this.$locales.filter(
        locale => locale.code === this.$i18n.locale
      )[0];
    },
    nonDefaultLocales() {
      return this.$locales.filter(locale => locale.code !== this.$i18n.locale);
    }
  },
  methods: {
    loadPropPath(locale) {
      let t = this.prop ? this.prop + ":" + locale : "";
      // console.log(t, this.prop);
      return t;
    },
    onToggleCollapse() {
      this.collapsed = !this.collapsed;
    },
    onDataChange(locale, value) {
      this.$set(this.value, locale, value);
    },
    onDefaultDataChange(locale, value) {
      let translate = "";

      if (locale === "uz-CYR") {
        this.value["uz-UZ"] = "";
        this.value["ru-RU"] = "";
        this.value["en-US"] = "";

        for (let i in value) {
          if (value.hasOwnProperty(i)) {
            translate +=
              this.uzCYRAlphabet.indexOf(value[i]) > 0
                ? this.uzUZAlphabet[this.uzCYRAlphabet.indexOf(value[i])]
                : value[i];
          }
          this.value["uz-UZ"] = translate;
          this.value["ru-RU"] = value;
          this.value["en-US"] = translate;
        }
      } else if (locale === "uz-UZ") {
        this.value["uz-CYR"] = "";
        this.value["ru-RU"] = "";
        this.value["en-US"] = "";

        for (let i in value) {
          if (value.hasOwnProperty(i)) {
            translate +=
              this.uzUZAlphabet.indexOf(value[i]) > 0
                ? this.uzCYRAlphabet[this.uzUZAlphabet.indexOf(value[i])]
                : value[i];
          }
          this.value["uz-CYR"] = translate;
          this.value["ru-RU"] = translate;
          this.value["en-US"] = value;
        }
      }

      this.$set(this.value, locale, value);
    }
  }
};
</script>

<style lang="scss" scoped>
.input-item {
  margin-bottom: 12px;
}
</style>
